import React, { useState, useEffect, useRef } from "react";
import tw from "twin.macro";
import { SectionHeading as HeadingTitle } from "../misc/Headings.js";

const STATS_DATA = [
  { label: "Graduates", urduLabel: "فارغين", value: 1750, icon: "🎓" },
  { label: "Students", urduLabel: "طلبہ", value: 715, icon: "👨‍🎓" },
  { label: "Courses", urduLabel: "مقررات", value: 148, icon: "📚" },
  { label: "Teachers", urduLabel: "اساتذه", value: 39, icon: "👨‍🏫" },
  { label: "Departments", urduLabel: "شعبہ جات", value: 18, icon: "🏛️" },
];

const AnimatedCounter = ({ end, duration = 2000 }) => {
  const [count, setCount] = useState(0);
  const countRef = useRef(null);
  const [hasStarted, setHasStarted] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !hasStarted) {
          setHasStarted(true);
        }
      },
      { threshold: 0.1 }
    );

    const currentRef = countRef.current;
    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [hasStarted]);

  useEffect(() => {
    if (!hasStarted) return;

    let startTime = null;
    const step = (timestamp) => {
      if (!startTime) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / duration, 1);
      setCount(Math.floor(progress * end));
      if (progress < 1) {
        window.requestAnimationFrame(step);
      }
    };
    window.requestAnimationFrame(step);
  }, [hasStarted, end, duration]);

  return <span ref={countRef}>{count}</span>;
};

const SectionHeading = tw.h2`text-4xl sm:text-5xl font-black tracking-wide text-center [font-family: "Noto Nastaliq Urdu", serif]`;

const StatCardDiv = tw.div`bg-white max-w-4xl p-6 rounded-4xl shadow-md border border-gray-200 flex flex-col items-center justify-center text-center transition-shadow duration-300 hover:shadow-xl`;
const IconDiv = tw.div`p-4 bg-primary-100 rounded-full text-primary-500 text-4xl mb-4`;
const ValueH3 = tw.h3`text-4xl  font-semibold text-gray-900 mb-1`;
const UrduP = tw.p`text-2xl font-bold text-gray-800 [font-family: "Noto Nastaliq Urdu", serif]`;
const LabelP = tw.p`text-xs text-gray-500 font-medium uppercase tracking-wider mt-1`;

const StatsContainer = tw.div`max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 pb-12 -mt--12`;
const StatsGrid = tw.div`grid grid-cols-1 md:grid-cols-5 gap-4 mb-16 shadow-xl rounded-2xl bg-white p-4 border border-gray-100`;

export default function StatsCounter() {
  return (
    <StatsContainer>
      <SectionHeading>جامعہ اعداد و شمار میں</SectionHeading>
      <StatsGrid>
        {STATS_DATA.map((stat, index) => (
          <StatCardDiv>
            <IconDiv>{stat.icon}</IconDiv>
            <ValueH3>
              <AnimatedCounter end={parseInt(stat.value)} />
            </ValueH3>
            <UrduP>{stat.urduLabel}</UrduP>
            <LabelP>{stat.label}</LabelP>
          </StatCardDiv>
        ))}
      </StatsGrid>
    </StatsContainer>
  );
}
